import React from 'react';
import { NavLink } from 'react-router-dom';
import { LayoutDashboard, FileText, Users, Settings, Building2, LogOut } from 'lucide-react';
import { cn } from '../../lib/utils';
import { useAppContext } from '../../lib/store';
import { Avatar, AvatarFallback } from '../ui/avatar';
interface SidebarProps {
  className?: string;
  onNavigate?: () => void;
}
export function Sidebar({
  className,
  onNavigate
}: SidebarProps) {
  const {
    auth,
    logout
  } = useAppContext();
  const navItems = [{
    to: '/',
    icon: LayoutDashboard,
    label: 'Nadzorna plošča'
  }, {
    to: '/nalogi',
    icon: FileText,
    label: 'Delovni nalogi'
  }, {
    to: '/stranke',
    icon: Building2,
    label: 'Stranke'
  }, {
    to: '/uporabniki',
    icon: Users,
    label: 'Uporabniki',
    adminOnly: true
  }, {
    to: '/nastavitve',
    icon: Settings,
    label: 'Nastavitve'
  }];
  const filteredNavItems = navItems.filter(item => !item.adminOnly || item.adminOnly && auth.user?.role === 'Admin');
  const handleLogout = (e: React.MouseEvent) => {
    e.preventDefault();
    logout();
  };
  return <div className={cn('flex flex-col h-full bg-primary text-primary-foreground', className)} data-id="element-49">
      <div className="p-5 flex items-center" data-id="element-50">
        <img src="https://cdn.magicpatterns.com/uploads/fwae64AkjzR1PZNPwPqUJx/simtech_(1).svg" alt="Simtech" className="h-10 brightness-0 invert" data-id="element-51" />
      </div>

      <nav className="flex-1 px-4 space-y-1 mt-4" data-id="element-52">
        {filteredNavItems.map(item => <NavLink key={item.to} to={item.to} onClick={onNavigate} className={({
        isActive
      }) => cn('flex items-center gap-3 px-3 py-2.5 rounded-md text-sm font-medium transition-colors', isActive ? 'bg-white/10 text-white' : 'text-primary-foreground/70 hover:bg-white/5 hover:text-white')} data-id="element-53">
            <item.icon className="w-5 h-5" data-id="element-54" />
            {item.label}
          </NavLink>)}
      </nav>

      <div className="p-4 mt-auto border-t border-white/10" data-id="element-55">
        <div className="flex items-center gap-3 mb-4 px-2" data-id="element-56">
          <Avatar className="w-9 h-9 border border-white/20" data-id="element-57">
            <AvatarFallback className="bg-primary-foreground text-primary" data-id="element-58">
              {auth.user?.full_name.split(' ').map(n => n[0]).join('')}
            </AvatarFallback>
          </Avatar>
          <div className="flex flex-col overflow-hidden" data-id="element-59">
            <span className="text-sm font-medium truncate" data-id="element-60">
              {auth.user?.full_name}
            </span>
            <span className="text-xs text-primary-foreground/60 truncate" data-id="element-61">
              {auth.user?.role}
            </span>
          </div>
        </div>
        <button onClick={handleLogout} className="flex items-center gap-3 px-3 py-2 w-full rounded-md text-sm font-medium text-primary-foreground/70 hover:bg-white/5 hover:text-white transition-colors" data-id="element-62">
          <LogOut className="w-5 h-5" data-id="element-63" />
          Odjava
        </button>
      </div>
    </div>;
}